const { defaultLanguage } = require('../../../config/prismic-configuration');

const linkResolver = doc => {
  const properties = doc._meta || doc;

  const { lang, uid, type } = properties || '';

  if (type === 'broken_type') {
    return;
  }

  if (type === 'homepage') {
    return `/${lang.slice(0, 2)}/blog/`;
  }

  if (
    type === 'page' ||
    type === 'contact' ||
    type === 'pricing' ||
    type === 'event_gallery' ||
    type === 'quote'
  ) {
    return `/${lang.slice(0, 2)}/${uid}/`;
  }

  if (type === 'event' || type === 'event_tag') {
    return `/${lang.slice(0, 2)}/templates/${uid}/`;
  }

  if (type === 'homepage_web') {
    return lang === defaultLanguage ? `/` : `/${lang.slice(0, 2)}/`;
  }

  return `/${lang.slice(0, 2)}/blog/${uid}/`;
};

module.exports = { linkResolver };
